// activityTradeStar
export default {
  routerTitle: '尋找盈寶港美股交易之星',
  shareTitle: '尋找盈寶港美股交易之星，最高攞HKD4000',
  shareDesc: '限时福利，多交易多得',

  welfare: '福利',
  seeMore: '查看更多',

  dayTradeDaBiao: '交易日內融筆數達標，獎勵高達',
  dtErWai: '額外再享免佣!',

  dtTableHeader1: '交易港/美股<br/>日內融筆數',
  dtTableHeader2: '獎勵金額<br/>累計金額',
  dtTableHeader3: '額外獎勵',
  monthFeeHk: '個月港股免佣券',
  dtTableTips: '注：免佣券獎勵需達標且活動結束後7個工作日內發放。',

  joinNow: '即刻參與',
  dtSupportStocks: '日內融支持股票',
  txkgStock: '騰訊控股（00700）',
  albbStock: '阿里巴巴-SW（09988）',
  bdjtStock: '百度集團-SW（09888）',
  jdjtStock: '京東集團-SW（09618）',
  mtStock: '美團-W（03690）',
  support20x: '支持20倍融资',

  howToOpenDt: '如何開通日內融',
  dtStep1: '第一步：即刻參與',
  dtStep2: '第二步：資產頁>點擊日內融入口',
  dtStep3: '第三步：開通日內融資帳戶',
  dtStep4: '第四步：日內融資交易',
  dtOperateIntroLabel: '具體操作指引',
  dtOperateIntroValue: '日內融資操作交易攻略指引',
  wbDtYsTitle: '盈寶日內融資的優勢',
  wbDtYs1: '高杠杆日內短線交易',
  wbDtYs2: '最高支持20倍杠杆',
  wbDtYs3: '0融资利息',
  wbDtYs4: '當天建倉，當天平倉',

  normalTradeDaBiao: '交易港/美股筆數達標，獎勵高達',
  perFute: '股福特股票',
  accumulate: '累計',
  tradeHkAndUs: '交易港/美股',
  perCount: '筆',
  perStock: '股',
  normalTradeTips: '注：港美股交易筆數不包含日內融的交易。',

  wbYsTitle: '盈寶優勢',
  wbDtYsDesc11: '多品種交易',
  wbDtYsDesc12: '支持港股、美股、牛熊渦輪內證、ETF',
  wbDtYsDesc21: '杠杆放大可能',
  wbDtYsDesc22: '20倍港美股日內融，放大投資機會',
  wbDtYsDesc31: '低利息成本',
  wbDtYsDesc32: '孖展利息低至5.6%，降低投資成本',
  wbDtYsDesc41: '會員特權',
  wbDtYsDesc42: 'V3會員專享0元佣金，交易1億港元僅需5元平台費',
  wbDtYsDesc51: '智能交易',
  wbDtYsDesc52: '條件單、止損止盈，策略在手，交易我有'
}
